<template>
	<QaLayout>
		<QaItem1/>
		<QaItem2/>
		<QaItem3/>
	</QaLayout>
</template>

<script>
import QaItem1 from './qaItem1.vue';
import QaItem2 from './qaItem2.vue';
import QaItem3 from './qaItem3.vue';
import QaLayout from './qaLayout.vue';

export default {
	components: {
		QaLayout,
		QaItem1,
		QaItem2,
		QaItem3,
	}
}
</script>